(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '@material-ui/core/styles', './TextInput', '@material-ui/core/IconButton', '@material-ui/icons/Close', '@material-ui/icons/Search', '../../styles'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('@material-ui/core/styles'), require('./TextInput'), require('@material-ui/core/IconButton'), require('@material-ui/icons/Close'), require('@material-ui/icons/Search'), require('../../styles'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.styles, global.TextInput, global.IconButton, global.Close, global.Search, global.styles);
    global.SearchInput = mod.exports;
  }
})(this, function (exports, _react, _styles, _TextInput, _IconButton, _Close, _Search, _styles2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _TextInput2 = _interopRequireDefault(_TextInput);

  var _IconButton2 = _interopRequireDefault(_IconButton);

  var _Close2 = _interopRequireDefault(_Close);

  var _Search2 = _interopRequireDefault(_Search);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SearchInput = function SearchInput(_ref) {
    var testId = _ref['data-testid'],
        classes = _ref.classes,
        onClickClose = _ref.onClickClose,
        onClickSearch = _ref.onClickSearch,
        placeholder = _ref.placeholder,
        onChange = _ref.onChange,
        value = _ref.value,
        isTextInputShown = _ref.isTextInputShown,
        onKeyUp = _ref.onKeyUp;
    return _react2.default.createElement(
      'div',
      { className: classes.root },
      _react2.default.createElement(
        _IconButton2.default,
        {
          'data-testid': 'click-search-icon-' + testId,
          'aria-label': 'Search',
          onClick: onClickSearch,
          color: 'primary',
          classes: { colorPrimary: classes.overrides }
        },
        _react2.default.createElement(_Search2.default, null)
      ),
      isTextInputShown && _react2.default.createElement(_TextInput2.default, {
        onKeyUp: onKeyUp,
        onChange: onChange,
        'data-testid': testId,
        fullWidth: true,
        placeholder: placeholder,
        type: 'text',
        value: value,
        endAdornment: _react2.default.createElement(
          _IconButton2.default,
          {
            'data-testid': 'click-close-icon-' + testId,
            'aria-label': 'Close',
            onClick: onClickClose,
            color: 'primary',
            classes: { colorPrimary: classes.overrides }
          },
          _react2.default.createElement(_Close2.default, null)
        )
      })
    );
  };


  var styles = {
    root: {
      display: 'flex'
    },
    overrides: {
      color: _styles2.colors.slate
    }
  };

  exports.default = (0, _styles.withStyles)(styles)(SearchInput);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Inputs/SearchInput.js
// module id = 1962
// module chunks = 1